export const SUPPORTED_BROWSERS_COOKIE_NAME = 'browser-warning';
